
export default {
    getPretensaoSalarial(state) {
        return state.pretensaoSalarial
    },
    getPretensoesSalariais(state) {
        return state.pretensoesSalariais
    },
}